import _ from 'lodash';

import report101 from 'views/Forms/report101.json';
import form00 from 'views/Forms/form00.json';
import form01 from 'views/Forms/form01.json';
import form02_01 from 'views/Forms/form02-01.json';
import form02_02 from 'views/Forms/form02-02.json';
import form02_03 from 'views/Forms/form02-03.json';
import form02_05 from 'views/Forms/form02-05.json';
import form02_06 from 'views/Forms/form02-06.json';
import form02_07 from 'views/Forms/form02-07.json';
import form02_08 from 'views/Forms/form02-08.json';
import form02_09 from 'views/Forms/form02-09.json';
import form02_10 from 'views/Forms/form02-10.json';
import form02_11 from 'views/Forms/form02-11.json';
import form02_12 from 'views/Forms/form02-12.json';
import form02_13 from 'views/Forms/form02-13.json';
import form02_14 from 'views/Forms/form02-14.json';
import form02_15 from 'views/Forms/form02-15.json';
import form02_16 from 'views/Forms/form02-16.json';
import form02_17 from 'views/Forms/form02-17.json';
import form02_18 from 'views/Forms/form02-18.json';
import form02_19 from 'views/Forms/form02-19.json';
import form02_20_1 from 'views/Forms/form02-20_1.json';
import form02_20_2 from 'views/Forms/form02-20_2.json';
import form02_20_3 from 'views/Forms/form02-20_3.json';

export const getFormDataFromSku = (sku) => {
  const data = sku === 'report101'
    ? report101
    : sku === 'form01'
      ? form01
      : sku === 'form02_01'
        ? form02_01
        : sku === 'form02_02'
          ? form02_02
          : sku === 'form02_03'
            ? form02_03
            : sku === 'form02_05'
              ? form02_05
              : sku === 'form02_06'
                ? form02_06
                : sku === 'form02_07'
                  ? form02_07
                  : sku === 'form02_08'
                    ? form02_08
                    : sku === 'form02_09'
                      ? form02_09
                      : sku === 'form02_10'
                        ? form02_10
                        : sku === 'form02_11'
                          ? form02_11
                          : sku === 'form02_12'
                            ? form02_12
                            : sku === 'form02_13'
                              ? form02_13
                              : sku === 'form02_14'
                                ? form02_14
                                : sku === 'form02_15'
                                  ? form02_15
                                  : sku === 'form02_16'
                                    ? form02_16
                                    : sku === 'form02_17'
                                      ? form02_17
                                      : sku === 'form02_18'
                                        ? form02_18
                                        : sku === 'form02_19'
                                          ? form02_19
                                          : sku === 'form02_20_1'
                                            ? form02_20_1
                                            : sku === 'form02_20_2'
                                              ? form02_20_2
                                              : sku === 'form02_20_3'
                                                ? form02_20_3
                                                : sku === 'form00'
                                                  ? form00
                                                  : null;
  return data;
}

export const sumScores = (obj) => {
  if (!obj) {
    return null;
  }
  let score = 0;
  Object.keys(obj).forEach(key => {
    switch (typeof obj[key]) {
      case 'object': {
        score += sumScores(obj[key]);
        break;
      }
      case 'number': {
        score += obj[key];
        break;
      }
      default: {
        //do nothing
      }
    }
  })
  return score;
}

export const get개선점 = (obj) => {
  if (!obj) {
    return null;
  }
  let 개선점 = [];
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object') {
      const _개선점 = get개선점(obj[key]);
      개선점 = [...개선점, ..._개선점];
    }
    if (/개선점$/.test(key) && obj[key] && obj[key].length > 0) {
      개선점 = [...개선점, { key, value: obj[key] }];
    }
  })

  console.log('개선점: ', 개선점);
  return 개선점;
}

export const sectionScores = (obj) => {
  let scores = {};
  Object.keys(obj).forEach(key => {
    scores = {
      ...scores, [key]: {
        score: sumScores(obj[key]),
        max: Object.keys(obj[key]).length
      }
    }
  })
  return scores;
}

export const calcultateBMI = (weight, height) => weight / (height * height);

// 활동(자립) - 치매 / 인지지원등급
export const analysis간이정신상태검사 = (valueState) => {
  if (!valueState) {
    return null;
  }

  const { 간이정신상태검사, 사전질문 } = valueState;
  const total = sumScores(간이정신상태검사);
  const sections = sectionScores(간이정신상태검사);
  const sectionNormals = _.keys(sections).map((key) => ({ section: key, percentile: sections[key].score / sections[key].max }));
  const weak = _.minBy(sectionNormals, 'percentile');
  const strong = _.maxBy(sectionNormals, 'percentile');

  return {
    total,
    sections,
    weak,
    strong
  };
}

// 활동(자립) - 수단적
export const analysis수단적일상생활활동 = (valueState) => {
  if (!valueState) {
    return null;
  }

  const { 수단적일상생활활동 } = valueState;
  const items = _.keys(수단적일상생활활동).map((key) => ({ section: key, ...수단적일상생활활동[key] }));
  const weak = _.maxBy(items, '현재실행');
  const strong = _.minBy(items, '현재실행');

  return {
    weak,
    strong
  }
}

// 활동(자립) - 기본적
export const analysis기본적일상생활활동 = (valueState) => {
  if (!valueState) {
    return null;
  }

  const { 기본적일상생활활동 } = valueState;
  const items = _.keys(기본적일상생활활동).map((key) => ({ section: key, score: 기본적일상생활활동[key][key] }));
  const weak = _.maxBy(items.filter(item => item.score > 0), 'score');
  const strong = _.minBy(items.filter(item => item.score < 2), 'score');

  return {
    weak,
    strong
  }
}

// 참여(사회심리) - 여가활동
export const analysis여가활동 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 여가활동: { 여가활동: records } } = valueState;
  const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  return {
    weak: _(weakItems).orderBy('score', 'desc').take(3).map('action').value().join(','),
    weakFull: _(weakItems).orderBy('score', 'desc').map('action').value().join(','),
    strong: _(strongItems).orderBy('score', 'asc').take(3).map('action').value().join(','),
    strongFull: _(strongItems).orderBy('score', 'asc').map('action').value().join(','),
  }
}

// 참여(사회심리) - 사회활동
export const analysis사회활동 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 사회활동: { 사회활동: records } } = valueState;
  const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  return {
    weak: _(weakItems).orderBy('score', 'desc').take(3).map('action').value().join(','),
    weakFull: _(weakItems).orderBy('score', 'desc').map('action').value().join(','),
    strong: _(strongItems).orderBy('score', 'asc').take(3).map('action').value().join(','),
    strongFull: _(strongItems).orderBy('score', 'asc').map('action').value().join(','),
  }
}

export const analysis정서 = (doc) => {
  if (!doc) {
    return null;
  }

  if (!doc.valueState) {
    return null;
  }

  const { valueState, score } = doc;
  const scoreDescription = score < 5
    ? '정상'
    : score < 10
      ? '경증 우울'
      : '중증(도) 우울';

  const { 스크리닝1, 스크리닝2 } = valueState?.스크리닝질문?.스크리닝질문;
  const 스크리닝 = 스크리닝1 + 스크리닝2;

  return {
    weak: 스크리닝 > 0 ? `우울증 점수: ${score} (${scoreDescription})` : '',
    strong: 스크리닝 === 0 ? '우울감을 느끼지 않음' : ''
  }

}

// 신체기능과 구조 (건강) - 건강상태
export const analysis건강상태 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 건강상태: { 만성질환, 신체계측, 통증, 투약 } } = valueState;
  return {
    weak: _(만성질환).values().flatten().value().filter(item => item).join(', '),
    strong: _.keys(투약).filter(key => /현재복용약./.test(key)).map(key => 투약[key]).filter(key => key).join(', '),
  }
  // const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  // const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  // const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  // return {
  //   weak: _(weakItems).orderBy('score', 'desc').take(3).map('action').value().join(','),
  //   strong: _(strongItems).orderBy('score', 'asc').take(3).map('action').value().join(','),
  // }

}

// 신체기능과 구조 (건강) - 생활습관
export const analysis생활습관 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 생활습관: { 수면, 음주, 흡연 } } = valueState;

  const { 음주여부, 음주주기, 주종 } = 음주;
  const { 흡연여부, 흡연량, 흡연경력 } = 흡연;
  const { 수면장애여부, 평균수면시간, 수면장애 } = 수면;

  let strong = `${음주여부 === 0 ? '금주, ' : ''}${흡연여부 === 0 ? '금연, ' : ''}${수면장애 === '' ? '수면장애 없음' : ''}`
  let weak = 음주여부 === 1 ? `음주: 주${음주주기}회 ${주종}\n` : '';
  weak += 흡연여부 === 1 ? `흡연: ${흡연경력}년 간, 하루 ${흡연량} 갑\n` : '';
  weak += 수면장애여부 === 1 ? `수면: 평균 ${평균수면시간} 시간 수면, ${수면장애}\n` : '';

  return {
    strong,
    weak
  };
  // const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  // const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  // const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  // return {
  //   weak: _(weakItems).orderBy('score', 'desc').take(3).map('action').value().join(','),
  //   strong: _(strongItems).orderBy('score', 'asc').take(3).map('action').value().join(','),
  // }
}

// 신체기능과 구조 (건강) - 신체활동
export const analysis신체활동 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 신체활동: { 운동 } } = valueState;
  // const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  // const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  // const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  return {
    weak: 운동?.운동여부 === 0 ? '운동 필요' : '',
    strong: 운동?.운동여부 === 1 ? `정기적인 운동: 주${운동?.운동주기}회 ${운동?.운동종류} ${운동?.운동시간}` : '',
  }

}

// 신체기능과 구조 (건강) - 영양
export const analysis영양 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 영양: { 영양 } } = valueState;

  const { BMI, 몸무게축소여부, 하루몇회식사, 소화계질병 } = 영양;

  const bmiDescription = BMI < 18.5
    ? '저체중'
    : BMI < 22.9
      ? '정상체중'
      : BMI < 24.9
        ? '과체중'
        : BMI < 29.9
          ? '경도비만'
          : '고도비만';

  return {
    weak: (bmiDescription !== '정상체중' ? `BMI: ${BMI} (${bmiDescription})` : '')
      + (몸무게축소여부 === 1 ? '최근에 몸무게가 줄어들었음' : '')
      + (하루몇회식사.length < 3 ? '식사끼니가 적습니다' : '')
      + (소화계질병.length > 0 ? `소화계통 질병(${소화계질병.join(', ')})이 있습니다.` : ''),
    strong: (bmiDescription === '정상체중' ? `BMI: ${BMI} (${bmiDescription})` : '')
      + (몸무게축소여부 === 0 ? '최근에 몸무게 변화는 없음.' : '')
      + (하루몇회식사.length > 2 ? '식사끼니가 적절합니다' : ''),
  }

  // const items = _.keys(records).map(key => ({ action: key, answers: records[key].constructor.name === "Array" ? records[key] : [] }));
  // const strongItems = items.filter(item => _.intersection(item.answers, [0, 1]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));
  // const weakItems = items.filter(item => _.intersection(item.answers, [1, 2]).length > 0).map(({ action, answers }) => ({ action, score: _.sum(answers) }));

  // return {
  //   weak: _(weakItems).orderBy('score', 'desc').take(3).map('action').value().join(','),
  //   strong: _(strongItems).orderBy('score', 'asc').take(3).map('action').value().join(','),
  // }

}



// 환경요인(안전, 지지) - 행동
export const analysis행동 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 정신행동증상 } = valueState;
  const 증상 = Object.keys(정신행동증상).map(key => ({ 증상: key, ...정신행동증상[key] }));
  const 관리가필요한증상 = _.sortBy(증상.filter(item => item.증상유무 === 1), { 심한정도: 'desc' });

  return {
    weak: 관리가필요한증상.length > 0 ? `관리가 필요한 증상: ${관리가필요한증상.map(item => item.증상).join(', ')}` : '',
    strong: 관리가필요한증상.length === 0 ? '정신행동증상 없음' : ''
  }
}
// 환경요인(안전, 지지) - 환경
export const analysis환경 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 기능촉진환경, 안전한환경 } = valueState;
  const 기능촉진환경score = sumScores(기능촉진환경);
  const 안전한환경score = sumScores(안전한환경);
  const 기능촉진환경_개선점 = get개선점(기능촉진환경);
  const 안전한환경_개선점 = get개선점(안전한환경);

  let strong = [], weak = [], weakFull = '';

  // max: 11
  if (기능촉진환경score > 8) {
    strong.push('기능촉진환경: 우수');
  }
  if (기능촉진환경score < 4) {
    weak.push('기능촉진환경: 취약');
  }

  // max: 20
  if (안전한환경score > 15) {
    strong.push('안전환경: 우수');
  }
  if (안전한환경score < 5) {
    weak.push('인전환경: 취약');
  }

  if (기능촉진환경_개선점 && 기능촉진환경_개선점.length) {
    weakFull += 기능촉진환경_개선점.map(item => `${item.key}:${item.value}`).join(',');
  }
  if (안전한환경_개선점 && 안전한환경_개선점.length) {
    weakFull += 안전한환경_개선점.map(item => `${item.key}:${item.value}`).join(',');
  }

  return {
    weak: weak.join(', '),
    strong: strong.join(', '),
    weakFull
  }
}
// 환경요인(안전, 지지) - 지원체계
export const analysis지원체계 = (valueState) => {
  if (!valueState) {
    return null;
  }
  const { 주거유형경제상태의료보장, 지역사회서비스 } = valueState;
  const 경제상태 = _.get(주거유형경제상태의료보장, '서비스와자원.경제상태');
  const 주거유형 = _.get(주거유형경제상태의료보장, '서비스와자원.주거유형');
  const 의료보장 = _.get(주거유형경제상태의료보장, '서비스와자원.의료보장');

  let weak = [], strong = [], weakFull = [], strongFull = [];

  switch (주거유형) {
    case '자가':
    case '전세':
    case '임대주택':
    case '무상임대':
      strong.push(`주거유형: 안정적(${주거유형})`);
      break;
    case '월세':
      weak.push(`주거유형: 불안정(${주거유형})`);
      break;
    case '기타':
      weak.push(`주거유형: 기타(${_.get(주거유형경제상태의료보장, '서비스와자원.주거유형_기타')})`);
      break;
    default:
    //do nothing
  }

  switch (경제상태) {
    case '안정':
    case '연금생활':
      strong.push(`경제상태: ${경제상태}`);
      break;
    case '불안정':
    case '국민기초수급':
      weak.push(`경제상태: ${경제상태}`);
      break;
    case '기타':
      weak.push(`경제상태(기타): ${_.get(주거유형경제상태의료보장, '서비스와자원.경제상태_기타')}`);
      break;
    default:
    // do nothing
  }

  switch (의료보장) {
    case '의료급여 1종':
    case '의료급여 2종':
      strong.push(`의료보장: ${의료보장}`);
      break;
    case '건강보험':
      weak.push(`의료보장: ${의료보장}`);
      break;
    case '기타':
      strong.push(`의료보장(기타): ${_.get(주거유형경제상태의료보장, '서비스와자원.의료보장_기타')}`);
      break;
    default:
  }

  Object.keys(지역사회서비스).forEach((key, idx) => {
    const item = 지역사회서비스[key];
    if (item?.제공받는서비스 && item.제공받는서비스.length > 0) {
      strongFull.push(`${key}: ${item.제공받는서비스}`);
    }
    if (item?.희망하는서비스 && item.희망하는서비스.length > 0) {
      weakFull.push(`${key}: ${item.희망하는서비스}`);
    }
  })

  const { 송영 } = 지역사회서비스;
  if (송영.도보가능여부 === '가능') {
    strong.push('도보가능');
  } else {
    weak.push(`도보불가능`);
  }

  if (송영.송영서비스필요여부 === '필요함') {
    weak.push(`차로 송영: ${송영.송영서비스필요여부}`)
  } else {
    strong.push(`차로 송영: ${송영.송영서비스필요여부}`)
  }


  return {
    weak: weak.join(', '),
    strong: strong.join(', '),
    weakFull: weakFull.join(', '),
    strongFull: strongFull.join(', ')
  }
}

// 환경요인(안전, 지지) - 돌봄환경
export const analysis돌봄환경 = (valueState) => {
  if (!valueState) {
    return null;
  }

  const { 돌봄상태, 돌봄역량, 돌봄부담 } = valueState;

  let weak = [], strong = [], weakFull = [], strongFull = [];

  if (돌봄상태) {
    const { 가족돌봄 } = 돌봄상태;
    const { 치매환자를주로돌보는가족, 돌보는가족_기타, 돌봄기간, 하루돌봄시간 } = 가족돌봄;

    strong = [
      ...strong,
      `주로 돌보는 가족: ${치매환자를주로돌보는가족}${돌보는가족_기타.length > 0 ? 돌보는가족_기타 : ''}`,
    ];

    // 가족돌봄
    strongFull = [
      ...strongFull,
      ...['가족1', '가족2', '가족3'].map(k => {
        const { 성명, 나이, 관계, 동거유무, 연락처, 비고 } = 돌봄상태[k];
        if (성명.length === 0) {
          return null;
        } else {
          return `${성명} ${나이.length > 0 ? `(${나이}세)` : ''} ${관계.length > 0 ? `${관계}` : ''} ${연락처.length > 0 ? `${연락처}` : ''}`;
        }
      })
    ];

  }

  if (돌봄역량) {
    const { 돌봄자신감, 치매교육 } = 돌봄역량;
    const { 돌봄자신감: _자신감 } = 돌봄자신감;
    const { 치매교육경험유무, 치매교육필요여부 } = 치매교육;

    strong = [
      ...strong,
      치매교육경험유무 === '예' ? `돌보는 가족이 치매 교육을 받은 경험이 있다.` : null,
      _자신감 > 5 ? `돌봄자신감(${_자신감}점)이 강한편이다` : null
    ];
  }

  if (돌봄부담) {
    const { 개인부담, 건강상태, 역할부담, 지지체계: { 도움을주는가족 } } = 돌봄부담;
    const 개인부담점수 = _.sum(Object.values(개인부담));
    const 역할부담점수 = _.sum(Object.values(역할부담));

    strong = [
      ...strong,
      개인부담점수 < 32 / 2 ? `개인부담감(${개인부담점수}점)이 적은편이다` : null,
      역할부담점수 < 16 / 2 ? `역할부담감(${역할부담점수}점)이 적은편이다` : null,
      건강상태?.건강상태 > 2 ? `돌보는 가족이 건강한 편이다.` : null
    ];

    weak = [
      ...weak,
      _.isEmpty(도움을주는가족) ? '등급자 돌봄에 도움을 주는 가족이 없음' : null,
      건강상태?.앓고있는질환 ? `돌보는 가족이 앓고 있는 질환: ${건강상태?.앓고있는질환}` : null,
      건강상태?.건강상태 < 3 ? `돌보는 가족의 건강이 나쁜 편이다` : null
    ]
  }


  return {
    weak: weak.filter(item => item !== null).join(', '),
    strong: strong.filter(item => item !== null).join(', '),
    weakFull: weakFull.filter(item => item !== null).join(', '),
    strongFull: strongFull.filter(item => item !== null).join(', ')
  }
}
// 개별요인(개별성) - 생활사
export const analysis생활사 = (valueState) => {

  if (!valueState) {
    return null;
  }

  const strong = [];
  const weak = [];
  const 하루일과 = [];

  const {
    가장행복했던순간,
    고향,
    기분좋은때,
    기상시간,
    나이,
    목욕샤워,
    몸단장,
    봉사활동,
    식사시간,
    싫어하는음식,
    쓰기,
    읽기,
    자는시간,
    종교,
    좋아하는음식,
    지금도하고싶은일,
    학력,
    함께사는가족,
  } = valueState?.생활사?.일반;

  if (가장행복했던순간 && 가장행복했던순간.length > 0) {
    strong.push(`행복했던순간: ${가장행복했던순간}`);
  }
  if (기분좋은때 && 기분좋은때.length > 0) {
    strong.push(`기분좋은때: ${기분좋은때}`);
  }
  if (좋아하는음식 && 좋아하는음식.length > 0) {
    strong.push(`좋아하는 음식: ${좋아하는음식}`);
  }
  if (지금도하고싶은일 && 지금도하고싶은일.length > 0) {
    strong.push(`지금도 하고싶은 일: ${지금도하고싶은일}`);
  }
  if (종교 && 종교.length > 0) {
    strong.push(`종교: ${종교}`);
  }

  if (싫어하는음식 && 싫어하는음식.length > 0) {
    weak.push(`싫어하는 음식: ${싫어하는음식}`);
  }

  switch (학력) {
    case '무학':
    case '초졸':
    case '중졸':
    case '고졸':
      weak.push(`학력: ${학력}`);
      break;
    case '대졸':
    case '대학원졸':
      strong.push(`학력: ${학력}`);
    default:
    //do nothing
  }

  if (기상시간 && 기상시간.length > 0) {
    하루일과.push(`기상시간: ${기상시간}`);
  }

  if (식사시간 && 식사시간.length > 0) {
    하루일과.push(`식사시간: ${식사시간}`);
  }

  if (자는시간 && 자는시간.length > 0) {
    하루일과.push(`자는시간: ${자는시간}`);
  }

  return {
    weak: weak.join(', '),
    strong: strong.join(', '),
    하루일과: `하루 일과\n${하루일과.join(', ')}`,
    읽기,
    쓰기
  }
}

// 개별요인(개별성) - 활동수준
export const analysis활동수준 = (valueState) => {
  if (!valueState) {
    return null;
  }

  const formData02_02 = getFormDataFromSku('form02_02');
  console.log('formData02_02', formData02_02);
  const { rows, columns } = formData02_02.sections[0];
  const { cellSelectionData, 활동수준 } = valueState;
  const strong = [];
  const weak = [];

  cellSelectionData.forEach((selectedId, idx) =>
    selectedId === 0
      ? strong.push(rows[idx].title)
      : weak.push(rows[idx].title));

  return {
    strong: strong.join(', '),
    weak: weak.join(', '),
    활동수준: 활동수준,
  }
}




const dementiaRiskTable = [
  [
    [20, 24, 25, 26],
    [19, 23, 25, 26]
  ],
  [
    [21, 23, 25, 26],
    [18, 21, 25, 26]
  ],
  [
    [20, 22, 25, 25],
    [17, 21, 24, 26]
  ],
  [
    [18, 22, 24, 25],
    [16, 20, 24, 27]
  ]
];


// 치매 판정식 결과
export const dementiaRiskCheck = (age, gender, education_years = 3, score) => {
  const age_group = age < 70
    ? 0
    : age < 75
      ? 1
      : age < 80
        ? 2
        : 3;
  const gender_group = gender === 1 ? 0 : 1;
  const edu_group = education_years < 4
    ? 0
    : education_years < 7
      ? 1
      : education_years < 13
        ? 2
        : 3
  return score < dementiaRiskTable[age_group][gender_group][edu_group] + 1;
}

export const dementiaRiskCheckWithEducationLevel = (age, gender, educationLevel = 1, score) => {
  const age_group = age < 70
    ? 0
    : age < 75
      ? 1
      : age < 80
        ? 2
        : 3;
  const gender_group = gender === 1 ? 0 : 1;
  return score < dementiaRiskTable[age_group][gender_group][educationLevel - 1] + 1;
}


export const educationLevelDescription = (educationLevel = 1) => {
  const eudcationLevels = ["0~3년", "4~6년(초졸)", "7~12년(중고졸)", "13년이상(대학이상)"];

  return eudcationLevels[educationLevel - 1];
}